import {
    ApiBaseService,
    type ApiServiceConfig,
    type PaginatedFetch,
    type PaginatedFetchOptions,
} from "~/services/ApiBaseService";
import type { Account, PartnerTenant } from "~/models/User";
import type { ApiResponse } from "~/types/ApiResponse";
import type { FetchOptions } from "ofetch";

export class PartnerTenantService extends ApiBaseService {
    constructor(config: ApiServiceConfig) {
        super(config);
    }

    public list(
        options?: Partial<PaginatedFetchOptions>,
    ): PaginatedFetch<PartnerTenant> {
        return this.paginate<PartnerTenant>(
            this.listRoute(),
            options as PaginatedFetchOptions,
        );
    }

    public listRoute(): string {
        return this.route("api.partner-tenants.index", "/partner-tenants");
    }

    public listRequest(
        options?: FetchOptions,
    ): Promise<ApiResponse<PartnerTenant[]>> {
        return this.request(this.listRoute(), options);
    }

    public listPartners(): Promise<ApiResponse<Account[]>> {
        return this.request(this.route("api.partner-tenants.partners", "/accounts/partnered"), {
            method: "GET",
        });
    }

    public create(
        data: Partial<
            Omit<Account, "domain" | "brand" | "location"> & {
                identifier: string;
                provider: string;
                domain_id: number;
                brand_id: number;
                location_id: number;
                brand_theme: any;
            }
        >,
    ): Promise<ApiResponse<Account>> {
        return this.request<ApiResponse<Account>>(
            this.route("api.partner-tenants.store", "/partner-tenants"),
            {
                headers: {
                    Accept: "application/json",
                },
                method: "POST",
                body: data,
            },
        );
    }

    public login(partnerTenantId: number): Promise<null> {
        return this.request<null>(
            this.route(
                "api.partner-tenants.login",
                `/partner-tenants/${partnerTenantId}/login`,
            ),
            {
                method: "POST",
            },
        );
    }

    public logout(): Promise<null> {
        return this.request<null>(
            this.route(
                "api.partner-tenants.logout",
                `/partner-tenants/logout`,
            ),
            {
                method: "DELETE",
            },
        );
    }
}
